import React, { Fragment, useState } from 'react';
import { Card, Button } from 'reactstrap';
import moment from 'moment';
import ReactHtmlParser from "react-html-parser";
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import EventsForm from './EventsForm';
export default function EventsList({ item, lang, LoadData, propertyId }) {
    const [isUpdating, setIsUpdating] = useState(false);
    return (
        <Fragment>
            <Colxx xxs="12">
                <Card className="d-flex flex-row mb-3">
                    <div className="pl-0 d-flex flex-grow-1 min-width-zero col-2">
                        <img
                            alt="Thumbnail"
                            src={
                                item.imageLink != ""
                                    ? item.imageLink
                                    : 'https://via.placeholder.com/250x150'
                            }
                            className="list-thumbnail responsive border-0"
                        />
                    </div>
                    <div className="pl-2 d-flex flex-grow-1 min-width-zero col-10">
                        <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                            <p className="mb-1 text-small w-50 w-sm-100">
                                <b>{item.title}</b>
                            </p>
                            <p className="mb-1 text-small w-50 w-sm-100">
                                {ReactHtmlParser(item.description.length > 50 ? item.description.substring(0, 50) + " ..." : item.description)}
                            </p>
                            <p className="mb-1 text-small w-50 w-sm-100">
                                <span className="text-muted text-small">Start Date - End Date</span><br/>
                                <b>{moment(item.startDate).format("DD-MM-YYYY")} - {moment(item.endDate).format("DD-MM-YYYY")}</b>
                            </p>
                            <p className="mb-1 text-muted text-small w-15 w-sm-100">
                                {item.status}
                            </p>
                            <div className="w-15 w-sm-100">
                                <Button
                                    color="primary"
                                    size="sm"
                                    onClick={() => setIsUpdating(!isUpdating)}
                                >
                                    Edit
                                </Button>
                            </div>
                        </div>
                    </div>
                </Card>
            </Colxx>
            {isUpdating &&
                <EventsForm
                    visible={isUpdating}
                    toggle={() => setIsUpdating(!isUpdating)}
                    id={item.id}
                    propertyId={propertyId}
                    languageCode={lang}
                    LoadData={LoadData}
                ></EventsForm>
            }
        </Fragment>
    )
}